module.exports = __webpack_public_path__ + "img/article10-3.8b2d9b89.jpg";